module.exports = __webpack_public_path__ + "img/123ne.f949567d.svg";